import { useSearchParams } from "react-router-dom"
import { Header } from "../../Header/Header"
import { SideBar } from "../../SideBar/SideBar"
import { Footer } from "../../../Footer/Footer"
import React, { useState } from "react"
import TrackPopup from "./TrackPopup/TrackPopup"
import { t } from "i18next"
import { Resolved } from "./Resolved"
import { Pending } from "./Pending"
import "../../../../theme/amchi-theme.css"

export const GrievanceStatus = () => {

    const [searchparams] = useSearchParams()
    const UserName = searchparams.get('UserName')
    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })
    // const navigate = useNavigate();
    return (
        <>

            {/* <!-- Page Wrapper --> */}
            <Header
                Language={Language}
                setLanguage={setLanguage}
            />
            <div id="wrapper" className="d-flex justify-content-center">
                {/* <!-- Content Wrapper --> */}
                <SideBar active="GrievanceStatus" UserName={UserName} />
                <div className="main-content user_dashboard d-flex flex-column body-scroll px-3" id='content' >
                    {/* <!-- Main Content --> */}
                    {/* <!-- Begin Page Content --> */}
                    <div className="container-fluid am-page am-page--embedded px-lg-3">
                        <div className="am-page-head am-rise pt-3">
                            <div>
                                <span className="am-pill"><i className="fa-solid fa-list-check"></i> {t('GrievanceStatus.GrievanceStatus')}</span>
                                <h1>{t('GrievanceStatus.GrievanceStatus')}</h1>
                                <p>
                                    तुमच्या तक्रारींची सद्यस्थिती येथे पहा. कार्डवर क्लिक करून संपूर्ण तपशील,
                                    <b> ट्रॅक</b> वापरून कार्यवाहीचा प्रवास व निराकरण झालेल्या तक्रारीवर
                                    <b> अभिप्राय</b> नोंदवता येईल.
                                </p>
                            </div>
                        </div>

                        <Resolved
                            Language={Language}
                            setLanguage={setLanguage} />
                        {/* <div className="row py-2 my-2 bg-white rounded">
                            <div className="col-12">
                                <h6 className="fw-bold text-danger">
                                    Pending Grievance
                                </h6>
                            </div>

                            <Pending />
                        </div> */}


                        {/* <Footer /> */}
                    </div>
                    {/* <!-- End of Content Wrapper --> */}
                    <Footer />
                </div>
            </div>
        </>

    )
}